const JmLogo = ({ scale, color, className }) => {
  const width = (1000 * parseFloat(scale)) | 1
  const height = (623 * parseFloat(scale)) | 1

  return (
    width &&
    height && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        className={className}
      >
        <g transform="matrix(1,0,0,1,-0.6060606060606233,0.2522267206477409)">
          <svg
            viewBox="0 0 396 247"
            data-background-color="#FFFFFF"
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              id="tight-bounds"
              transform="matrix(1,0,0,1,0.2400000000000091,-0.09999999999999432)"
            >
              <svg viewBox="0 0 395.52 247.2" height="247.2" width="395.52">
                <g>
                  <svg></svg>
                </g>
                <g>
                  <svg viewBox="0 0 395.52 247.2" height="247.2" width="395.52">
                    <g transform="matrix(1,0,0,1,75.54432,103.51674025047438)">
                      <svg
                        viewBox="0 0 244.43135999999998 40.16651949905123"
                        height="40.16651949905123"
                        width="244.43135999999998"
                      >
                        <g>
                          <svg
                            viewBox="0 0 244.43135999999998 40.16651949905123"
                            height="40.16651949905123"
                            width="244.43135999999998"
                          >
                            <g>
                              <svg
                                viewBox="0 0 244.43135999999998 40.16651949905123"
                                height="40.16651949905123"
                                width="244.43135999999998"
                              >
                                <g>
                                  <svg
                                    viewBox="0 0 244.43135999999998 40.16651949905123"
                                    height="40.16651949905123"
                                    width="244.43135999999998"
                                  >
                                    <g>
                                      <svg
                                        viewBox="0 0 244.43135999999998 40.16651949905123"
                                        height="40.16651949905123"
                                        width="244.43135999999998"
                                      >
                                        <g>
                                          <svg
                                            viewBox="0 0 244.43135999999998 40.16651949905123"
                                            height="40.16651949905123"
                                            width="244.43135999999998"
                                          >
                                            <g transform="matrix(1,0,0,1,0,0)">
                                              <svg
                                                width="244.43135999999998"
                                                viewBox="1.5 -33.70000076293945 263.4800109863281 43.30000305175781"
                                                height="40.16651949905123"
                                                data-palette-color="#000000"
                                              >
                                                <path
                                                  d="M14.1-33.7L14.1-8.65Q14.1 0 6.25 0L6.25 0Q3.45 0 1.5-1.1L1.5-1.1 1.5-5Q3.5-3.7 5.7-3.7L5.7-3.7Q10.05-3.7 10.05-8.3L10.05-8.3 10.05-33.7 14.1-33.7ZM43.85-12.6L43.85-12.6Q43.85-6.95 40.65-3.25 37.45 0.45 31.85 0.45L31.85 0.45Q26.4 0.45 23.22-3.23 20.05-6.9 20.05-12.5L20.05-12.5Q20.05-18.15 23.32-21.93 26.6-25.7 31.85-25.7L31.85-25.7Q37.6-25.7 40.72-22 43.85-18.3 43.85-12.6ZM24.15-12.55L24.15-12.55Q24.15-8.6 26.25-5.83 28.35-3.05 31.85-3.05L31.85-3.05Q35.65-3.05 37.7-5.78 39.75-8.5 39.75-12.55L39.75-12.55Q39.75-16.75 37.8-19.48 35.85-22.2 31.85-22.2L31.85-22.2Q28.25-22.2 26.2-19.4 24.15-16.6 24.15-12.55ZM53.55-13.85L53.55 0 49.6 0 49.65-25.35 53.55-25.35 53.55-20.9Q55.55-25.6 60.45-25.6L60.45-25.6Q61.35-25.6 61.85-25.5L61.85-25.5 61.85-21.6Q60.8-21.95 59.7-21.95L59.7-21.95Q57.05-21.95 55.3-19.5 53.55-17.05 53.55-13.85L53.55-13.85ZM86.39-25.35L86.39-2.05Q86.39 3.75 83.19 6.68 79.99 9.6 74.94 9.6L74.94 9.6Q70.34 9.6 67.09 8.05L67.09 8.05 67.09 4.1Q70.29 5.95 74.59 5.95L74.59 5.95Q78.24 5.95 80.34 4 82.44 2.05 82.44-2.1L82.44-2.1 82.44-4.95Q79.94-0.65 74.99-0.65L74.99-0.65Q70.64-0.65 67.57-3.85 64.49-7.05 64.49-12.75L64.49-12.75Q64.49-18.4 67.34-22.05 70.19-25.7 74.79-25.7L74.79-25.7Q79.99-25.7 82.44-21.15L82.44-21.15 82.44-25.35 86.39-25.35ZM68.59-12.85L68.59-12.85Q68.59-8.6 70.69-6.38 72.79-4.15 75.44-4.15L75.44-4.15Q78.19-4.15 80.32-6.28 82.44-8.4 82.44-12.6L82.44-12.6Q82.44-17.45 80.39-19.8 78.34-22.15 75.64-22.15L75.64-22.15Q72.39-22.15 70.49-19.58 68.59-17 68.59-12.85ZM111.89-5L111.89-1.3Q108.94 0.25 104.69 0.25L104.69 0.25Q98.94 0.25 95.42-3.28 91.89-6.8 91.89-12.6L91.89-12.6Q91.89-18.65 95.04-22.15 98.19-25.65 103.14-25.65L103.14-25.65Q107.89-25.65 110.69-22.6 113.49-19.55 113.49-13.95L113.49-13.95Q113.49-12.35 113.24-11L113.24-11 95.94-11Q96.39-7.25 98.79-5.25 101.19-3.25 105.09-3.25L105.09-3.25Q109.34-3.25 111.89-5L111.89-5ZM103.14-22.2L103.14-22.2Q100.29-22.2 98.29-20.15 96.29-18.1 95.94-14.3L95.94-14.3 109.54-14.3 109.54-15.3Q109.54-18.45 107.84-20.33 106.14-22.2 103.14-22.2ZM124.34-13.3L123.39 0 119.34 0 121.79-33.7 126.94-33.7 131.39-21.4 136.79-5.7Q139.69-13.9 142.49-21.4L142.49-21.4 147.14-33.7 152.29-33.7 155.24 0 151.19 0 150.04-13.3 148.84-28.25Q146.19-20.85 143.39-13.3L143.39-13.3 138.69-0.75 134.84-0.75 130.39-13.3 125.29-27.95Q125.29-26 124.34-13.3L124.34-13.3ZM184.63-12.6L184.63-12.6Q184.63-6.95 181.44-3.25 178.24 0.45 172.63 0.45L172.63 0.45Q167.19 0.45 164.01-3.23 160.84-6.9 160.84-12.5L160.84-12.5Q160.84-18.15 164.11-21.93 167.38-25.7 172.63-25.7L172.63-25.7Q178.38-25.7 181.51-22 184.63-18.3 184.63-12.6ZM164.94-12.55L164.94-12.55Q164.94-8.6 167.03-5.83 169.13-3.05 172.63-3.05L172.63-3.05Q176.44-3.05 178.49-5.78 180.53-8.5 180.53-12.55L180.53-12.55Q180.53-16.75 178.59-19.48 176.63-22.2 172.63-22.2L172.63-22.2Q169.03-22.2 166.99-19.4 164.94-16.6 164.94-12.55ZM210.43-17.45L210.43 0 206.48 0 206.48-16.4Q206.48-19.2 205.06-20.68 203.63-22.15 201.33-22.15L201.33-22.15Q198.48-22.15 196.41-19.95 194.33-17.75 194.33-13.85L194.33-13.85 194.33 0 190.43 0 190.43-25.35 194.33-25.35 194.33-20.95Q196.58-25.7 202.33-25.7L202.33-25.7Q206.03-25.7 208.23-23.45 210.43-21.2 210.43-17.45L210.43-17.45ZM237.88-25.35L237.88-2.05Q237.88 3.75 234.68 6.68 231.48 9.6 226.43 9.6L226.43 9.6Q221.83 9.6 218.58 8.05L218.58 8.05 218.58 4.1Q221.78 5.95 226.08 5.95L226.08 5.95Q229.73 5.95 231.83 4 233.93 2.05 233.93-2.1L233.93-2.1 233.93-4.95Q231.43-0.65 226.48-0.65L226.48-0.65Q222.13-0.65 219.06-3.85 215.98-7.05 215.98-12.75L215.98-12.75Q215.98-18.4 218.83-22.05 221.68-25.7 226.28-25.7L226.28-25.7Q231.48-25.7 233.93-21.15L233.93-21.15 233.93-25.35 237.88-25.35ZM220.08-12.85L220.08-12.85Q220.08-8.6 222.18-6.38 224.28-4.15 226.93-4.15L226.93-4.15Q229.68-4.15 231.81-6.28 233.93-8.4 233.93-12.6L233.93-12.6Q233.93-17.45 231.88-19.8 229.83-22.15 227.13-22.15L227.13-22.15Q223.88-22.15 221.98-19.58 220.08-17 220.08-12.85ZM263.38-5L263.38-1.3Q260.43 0.25 256.18 0.25L256.18 0.25Q250.43 0.25 246.9-3.28 243.38-6.8 243.38-12.6L243.38-12.6Q243.38-18.65 246.53-22.15 249.68-25.65 254.63-25.65L254.63-25.65Q259.38-25.65 262.18-22.6 264.98-19.55 264.98-13.95L264.98-13.95Q264.98-12.35 264.73-11L264.73-11 247.43-11Q247.88-7.25 250.28-5.25 252.68-3.25 256.58-3.25L256.58-3.25Q260.83-3.25 263.38-5L263.38-5ZM254.63-22.2L254.63-22.2Q251.78-22.2 249.78-20.15 247.78-18.1 247.43-14.3L247.43-14.3 261.03-14.3 261.03-15.3Q261.03-18.45 259.33-20.33 257.63-22.2 254.63-22.2Z"
                                                  opacity="1"
                                                  transform="matrix(1,0,0,1,0,0)"
                                                  fill={color}
                                                  className="undefined-text-0"
                                                  data-fill-palette-color="primary"
                                                  id="text-0"
                                                ></path>
                                              </svg>
                                            </g>
                                          </svg>
                                        </g>
                                      </svg>
                                    </g>
                                  </svg>
                                </g>
                              </svg>
                            </g>
                          </svg>
                        </g>
                      </svg>
                    </g>
                    <path
                      d="M211.824 97.517L211.824 35.217 388.59 35.217 388.59 211.983 211.824 211.983 211.824 149.683 215.446 149.683 215.446 208.361 384.967 208.361 384.967 38.839 215.446 38.839 215.446 97.517Z"
                      fill={color}
                      stroke="transparent"
                      data-fill-palette-color="primary"
                    ></path>
                  </svg>
                </g>
              </svg>
              <rect
                width="395.52"
                height="247.2"
                fill="none"
                stroke="none"
                visibility="hidden"
              ></rect>
            </g>
          </svg>
        </g>
      </svg>
    )
  )
}

export default JmLogo
